<template>
	<div class="container">
		<div class="row">
			<div class="col-sm-6 col-md-6 col-lg-3 mb-4" v-for="member in component.data.items">
				<div
						:style="{backgroundImage: `url('${member.img_path}')`, cursor: 'pointer'}"
						class="p-3 text-white colleagues__item border shadow"
						@click="member.show = !member.show"
				>
					<div class="colleagues__item-overlay d-flex align-items-end" :class="member.show ? 'colleagues__item-overlay--click' : ''">
						<div class="d-flex flex-column p-3">
							<template v-if="!member.show">
								<p class="fw-bold mb-0 colleagues__item--title">{{ member.name }}</p>
								<p class="mb-2 mt-0 colleagues__item--description">{{ member.title }}</p>
								<p v-if="member?.email?.length" class="fw-light colleagues__item--description">{{ member.email }}</p>
								{{ member.linkedin }}
								<a v-if="member?.linked_in?.length" :href="member.linked_in" class="text-white" target="_blank">
									<i class="colleagues__item--icon fa-brands fa-linkedin-in"></i>
									<span class="d-md-none text-decoration-underline fw-lighter">LinkedIn profil &#187;</span>
								</a>
							</template>
							<template v-else>
								<p class="fw-bold mb-3 colleagues__item--title">{{ member.name }}</p>
								<p class="colleagues__item--description">{{ member.short_description }}</p>
							</template>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import {PageComponentInterface} from "../Interfaces/PageComponentInterface";

export default defineComponent({
	name: "TeamComponent",
	props: {
		component: {
			type: Object as PropType<PageComponentInterface>,
			required: true,
		}
	},
});
</script>

<style scoped></style>
